import { useController } from 'react-hook-form';
import type { ColumnOrderState, OnChangeFn, Updater } from '@tanstack/react-table';
import { useCallback } from 'react';

export const useColumnOrderState = (): [ColumnOrderState, OnChangeFn<ColumnOrderState>] => {
  const { field } = useController({ name: 'columnOrder' });

  const onColumnOrderChange: OnChangeFn<ColumnOrderState> = useCallback(
    (updaterOrValue: Updater<ColumnOrderState>) => {
      const nextState = typeof updaterOrValue === 'function' ? updaterOrValue(field.value) : updaterOrValue;

      field.onChange(nextState);
    },
    [field],
  );

  return [field.value, onColumnOrderChange];
};
